import React, { useCallback, useEffect, useRef, useState } from 'react'
import { workoutResourceVersionListPromise } from 'api/WorkoutResourceVersion'
import WorkoutResourceVersionToolbar from './toolbar'
import WorkoutResourceVersionTable from './table'
import { useLocation } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import _ from 'lodash'

const WorkoutResourceList = props => {
  const ref = useRef()
  const location = useLocation()
  const [params, setParams] = useState({ page: 1 })
  const [data, setData] = useState([])


  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    workoutResourceVersionListPromise(too).then(resp => setData(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (payload) {
    handleParamsChange(payload, 500)
  }
  // end

  return (
    <div className={'root'}>
      <div className={'content'}>
        <WorkoutResourceVersionToolbar params={params} handleSearch={handleSearchChange} { ...props } />
        <br />
        <WorkoutResourceVersionTable data={data || []} page={params.page} onPageChange={handlePageChange} { ...props } />
      </div>
    </div>
  )
}

export default WorkoutResourceList
